import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/email.svg'
import _imports_1 from '@/assets/lock.svg'


const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = { class: "login-content" }
const _hoisted_3 = { class: "extra-options" }

import { ref, watch } from 'vue';
import { UserInfo } from '@/types/user/UserInfo';
import { PublicKeyResponse } from '@/types/user/response/PublicKeyResponse';
import { ApiResponse } from '@/types/ApiResponse';
import { LoginResponse } from '@/types/user/response/LoginResponse';
import { UserLoginRequest } from '@/types/user/request/UserLoginRequest';
import { userService } from "@/services/UserService";
import JSEncrypt from 'jsencrypt';
import { ElMessage }  from 'element-plus'
// 定义 props 和 emits

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginDialogComponent',
  props: {
    visible: {
        type: Boolean,
        required: true,
    },
},
  emits: ["update:visible", "login-success"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 控制弹窗显示
const visible = ref(props.visible);

// 监听 props.visible 的变化
watch(() => props.visible, (newVal) => {
    visible.value = newVal;
});

// 监听 visible 的变化，通知父组件
watch(visible, (newVal) => {
    emit('update:visible', newVal);
});

// 表单数据
const email = ref('');
const password = ref('');
const rememberMe = ref(false);

// 登录请求数据
const loginRequest = ref<UserLoginRequest>({
    type: 'email', // 固定为邮箱登录
    password: '',
    email: '',
});

const RASResponse = ref<ApiResponse<PublicKeyResponse>>();
const user = ref<ApiResponse<LoginResponse>>();
const userInfo = ref<UserInfo>();

// 登录方法
const login = async () => {
    loginRequest.value.email = email.value;
    loginRequest.value.password = password.value;

    // 获取公钥用于加密
    const response = await userService.getPublicKey();
    RASResponse.value = response;
    loginRequest.value.key_id = RASResponse.value.data.key_id;

    // 对密码加密
    const encryptpassword = encryptPassword(loginRequest.value.password);
    if (!encryptpassword) {
        return;
    }
    loginRequest.value.password = encryptpassword;

    // 发起登录请求
    const loginResponse = await userService.userlogin(loginRequest.value);
    user.value = loginResponse;

    // 如果登录成功，则存储到 localStorage
    if (user.value.code === 200) {
        localStorage.setItem('token', JSON.stringify(user.value.data.token));
        localStorage.setItem('user', JSON.stringify(user.value.data.data));
        userInfo.value = JSON.parse(JSON.stringify(user.value.data.data));
        // alert(userInfo.value)
        // 触发登录成功事件
        emit('login-success', userInfo.value as UserInfo);
        visible.value = false; // 关闭弹窗
    } else if (user.value.code === 1002) {
        ElMessage({
            message: "账号密码错误，如果忘记，请联系管理员",
            type: "error",
            duration:3000
        })
            
    }
};

// 加密方法
const encryptPassword = (password: string) => {
    const encrypt = new JSEncrypt();
    if (RASResponse.value?.data.public_key) {
        encrypt.setPublicKey(RASResponse.value.data.public_key);
        return encrypt.encrypt(password);
    }
    return false;
};

// 关闭弹窗
const closeDialog = () => {
    visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    width: "390",
    "max-width": "550px",
    "custom-class": "login-dialog",
    "close-on-click-modal": false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "dialog-title" }, "登录", -1)),
        _createVNode(_component_el_button, {
          class: "close-btn",
          icon: "el-icon-close",
          onClick: closeDialog
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          placeholder: "请输入邮箱",
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          "prefix-icon": "el-icon-message"
        }, {
          prefix: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "email",
              class: "input-icon"
            }, null, -1)
          ])),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          placeholder: "请输入密码",
          modelValue: password.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          type: "password",
          "show-password": ""
        }, {
          prefix: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "lock",
              class: "input-icon"
            }, null, -1)
          ])),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        class: "login-btn",
        onClick: login
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("登录")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_checkbox, {
          modelValue: rememberMe.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rememberMe).value = $event))
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("十天内免登录")
          ])),
          _: 1
        }, 8, ["modelValue"]),
        _cache[9] || (_cache[9] = _createElementVNode("a", {
          href: "#",
          class: "forget-password"
        }, "忘记密码?", -1))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})